<div class="drawer-header border-bottom">
  <span class="title">Detalhes do estudante</span>
  <p-button (onClick)="closeModal()" icon="pi pi-times" [rounded]="true" [text]="true" severity="secondary" />
</div>
<div class="content-drawer">
  <br>
  <div class="basic-info">
    <div class="avatar">
      <p-avatar
        *ngIf="!imageError && imagePreview; else defaultAvatar"
        [image]="$any(imagePreview)"
        shape="circle"
        size="xlarge"
        (onImageError)="imageError = true"
      />
      <ng-template #defaultAvatar>
        <p-avatar
          [label]="getInitials(estudanteSelected?.nome)"
          [icon]="!estudanteSelected?.nome ? 'pi pi-user' : undefined"
          shape="circle"
          size="xlarge"
        />
      </ng-template>
    </div>
    <div class="details">
      <h3 class="name">{{ estudanteSelected?.nome || 'sem informações disponíveis de momento' }}</h3>
      <div class="info">
        <span> <strong> Nº BI: {{ estudanteSelected?.numeroBI || 'sem informações disponíveis de momento' }}
          </strong></span>
        <span>&nbsp; • &nbsp;</span>
        <span> <p-tag *ngIf="estudanteSelected?.isActive" severity="success" value="Activo" />
          <p-tag *ngIf="!estudanteSelected?.isActive" severity="danger" value="Inactivo" /> </span>
        <span>&nbsp; • &nbsp;</span>
        <span><strong>{{estudanteSelected?.provinciaResidencia?.designacao}}</strong></span> • Criado Por - <span>{{
          estudanteSelected?.criadoPorNome }}</span>
      </div>
    </div>
  </div>
  <br>

  <!-- MATRÍCULA ATUAL -->
  <ng-container *ngIf="matriculaAtual as m; else elseTemplate">
    <div class="matricula-card p-3 border-round surface-card shadow-1">
      <div class="flex align-items-center gap-2 mb-2">
        <i class="pi pi-book text-primary"></i>
        <span class="title text-uppercase">Matrícula atual</span>
      </div>

      <div class="grid">
        <div class="col-12 md:col-3">
          <small class="block text-600 text-uppercase">Unid. Orgânica — Instituição</small>
          <div class="font-semibold text-uppercase">{{ currentUnidInst || '—' }}</div>
        </div>
        <div class="col-12 md:col-3">
          <small class="block text-600 text-uppercase">Fase</small>
          <div class="text-xl font-semibold text-uppercase">{{ currentFase || '—' }}</div>
        </div>
        <div class="col-12 md:col-3">
          <small class="block text-600 text-uppercase">Curso</small>
          <div class="text-xl font-semibold text-uppercase">{{ currentCurso || '—' }}</div>
        </div>
        <div class="col-12 md:col-3">
          <small class="block text-600 text-uppercase">Ano Curricular</small>
          <div class="text-xl font-semibold text-uppercase">{{ currentAnoCurricular || '—' }}</div>
        </div>



      </div>
    </div>
  </ng-container>
  <ng-template #elseTemplate>
    <div class="matricula-card p-3 border-round surface-card shadow-1">
      <div class="flex align-items-center gap-2 mb-2">
        <i class="pi pi-book text-primary"></i>
        <span class="title">Matrícula atual</span>
      </div>
      <div class="text-xl font-semibold text-uppercase">Sem informações disponíveis de momento</div>
    </div>
  </ng-template>




  <div class="section-detail">
    <div class="card-info">
      <div class="icon">
        <i class="pi pi-phone"></i>
      </div>
      <div class="description">
        <span class="title">Telefone</span>
        <span class="info">{{ estudanteSelected?.contactoPrincipal || 'sem informações disponíveis de momento' }}</span>
      </div>
    </div>
    <div class="card-info">
      <div class="icon">
        <i class="pi pi-envelope"></i>
      </div>
      <div class="description">
        <span class="title">Contacto de um familiar</span>
        <span class="info">{{ estudanteSelected?.contactoFamiliar || 'sem informações disponíveis de momento' }}</span>
      </div>
    </div>
  </div>

  <div class="section-detail">
    <div class="card-info">
      <div class="icon">
        <i class="pi pi-calendar-plus"></i>
      </div>
      <div class="description">
        <span class="title">Data de nascimento</span>
        <span class="info">{{ estudanteSelected?.dataNascimento ? (estudanteSelected.dataNascimento | date:'dd-MM-yyyy')
          : 'Sem informações disponíveis de momento' }}</span>
      </div>
    </div>
    <div class="card-info">
      <div class="icon">
        <i class="pi pi-map-marker"></i>
      </div>
      <div class="description">
        <span class="title">Endereço </span>
        <span class="info"> {{estudanteSelected?.endereco || 'sem informações disponíveis de momento' }} </span>
      </div>
    </div>
  </div>

  <div class="section-detail">
    <div class="card-info">
      <div class="icon">
        <i class="pi pi-graduation-cap"></i>
      </div>
      <div class="description">
        <span class="title">Nivel Académico</span>
        <span class="info">{{estudanteSelected?.nivelAcademicoDescricao || 'sem informações disponíveis de momento'
          }}</span>
      </div>
    </div>
    <div class="card-info">
      <div class="icon">
        <i class="pi pi-briefcase"></i>
      </div>
      <div class="description">
        <span class="title">Tipo de Bolsa</span>
        <span class="info"> {{estudanteSelected?.bolsas?.tipoBolsa || 'sem informações disponíveis de momento' }}
        </span>
      </div>
    </div>
  </div>

  <div class="about mt-4">
    <span class="title">Sobre o estudante</span>
    <p>{{ estudanteSelected?.sobreEstudante || 'sem informações disponíveis de momento' }}</p>
  </div>

  <div class="bolsas">
    <div class="bolsa-item">

    </div>
  </div>

  <div class="about mt-4">
    <span class="title">Informações Extras</span>
    <div class="about-group">
      <div class="extra">
        <span class="title">IBAN</span>
        <h4 class="info">{{estudanteSelected?.iban || 'sem informações disponíveis de momento'}}</h4>
      </div>
      <div class="extra">
        <span class="title">Número de Conta</span>
        <h4 class="info">{{estudanteSelected?.numeroConta || 'sem informações disponíveis de momento'}}</h4>
      </div>
      <div class="extra">
        <span class="title">Nome da Mãe</span>
        <h4 class="info">{{estudanteSelected?.nomeMae || 'sem informações disponíveis de momento'}}</h4>
      </div>
      <div class="extra">
        <span class="title">Nome do Pai</span>
        <h4 class="info">{{estudanteSelected?.nomePai || 'sem informações disponíveis de momento'}}</h4>
      </div>
      <div class="extra">
        <span class="title">Género</span>
        <h4 class="info">{{estudanteSelected?.generoDescricao || 'sem informações disponíveis de momento'}}</h4>
      </div>
      <div class="extra">
        <span class="title">Estado civil</span>
        <h4 class="info">{{estudanteSelected?.estadoCivilDescricao || 'sem informações disponíveis de momento'}}</h4>
      </div>
    </div>
  </div>

</div>